import React, {Component, Fragment} from "react";
import {b64toBlob, parseJwt, serviceApiResponse} from "../ServiciosMaestros/request";
import CustomizedSnackbars from "../Helpers/Alerts";
import {toast} from "react-toastify";
import { Elastic, Flex, MyCampo, Mycard, Transition} from "../ui";
import {Btn } from "./../UI-Components/Btn";
import {css} from "@emotion/core";
import ReactTooltip from "react-tooltip";
import MyRadio from "../Helpers/Radios";
import Script from "react-load-script";
import {FooterFactura, Line} from "./index";
import {withRouter} from "react-router";
import {api} from "../ServiciosMaestros/apis";
import {Collapse} from "@material-ui/core";

let ruta = {};

class FacturaPagarOnline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingDownload: false,
            infoFactura: [],
            expanded:false,
            infoCabecera: {},
            infoEmpresa: {},
            total: 0,
            isSuscrito: null,
            moneda: "COP",
            iva: 0,
            facturasCheckout: "",
            opcionesRecaudo: null,
            otroValor: 0,
            otroValorChecked: false,
            abonos: [],
            opcionPago: [],
            facturas: [],
            configuracionCampos:[],
            showMessage:{
                open: false,
                type: 'info',
                isDelay: false,
                message : ''
            },
            objectValor: {},
            fechasValidacion: [],
            loadingSuscripciones: false,
            pagoMinimoMoneda: "$ 0",
        };
        this.FormatoCampo = this.FormatoCampo.bind(this);
    }

    componentWillMount() {
        ruta = JSON.parse(sessionStorage.getItem("rutas"));
        this.setState({
            opcionesRecaudo:
                JSON.parse(sessionStorage.getItem("opcionesRecaudo")) || null
        });
        if (typeof this.props.location.isSuscrito === 'undefined')
            this.props.history.push(ruta.home);

        const isSuscrito = this.props.location.isSuscrito;
        if (isSuscrito) {
            this.setState({ isSuscrito: isSuscrito });
        }
    }

    componentDidMount() {
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
        let facturas = JSON.parse(sessionStorage.getItem("facturas"));
        let opcionesRecaudo = JSON.parse(sessionStorage.getItem('opcionesRecaudo'))
        let informacionSession = JSON.parse(sessionStorage.getItem('informacion'))
        opcionesRecaudo = opcionesRecaudo.moneda ? opcionesRecaudo : {moneda: {value: informacionSession.moneda ? informacionSession.moneda : 'COP'}}
        let key = sessionStorage.getItem("facturaPagar") ? JSON.parse(sessionStorage.getItem("facturaPagar")) : [0];
        let key2=[];
        if(key.length>1){
            key.forEach((it,k)=>{
                if(k<=facturas.length){
                    key2.push(it);
                }
            });
            key=key2;
        }
        if(typeof key ==="number"){
            key=[key];
        }
        let param= JSON.parse(sessionStorage.getItem("param")) ;

        let infoCabecera = {
            titulo: "Pagos Online",
            valor: "",
            referencia: "Pagos Online",
            option: "Pagos Online",

        };
        let configuracion=JSON.parse(sessionStorage.getItem("configuracion"));
        let facturasCopy=[];
        let abonos=[];
        let opcionPago=[];
        if (facturas && facturas.length > 0) {
            let total = 0;
            let moneda = configuracion.info.moneda;
            let iva=0;
            let fact=[];
            let entidadValor="";
            let entidadIva="";
            let idCheckout="";
            let valorCheckout="";
            let objectValorCheckout={};
            let aux=false;
            key.forEach((ks)=>{
                if(facturas[ks]!==undefined){
                    facturas[ks]["expanded"] = false;
                    fact.push(facturas[ks]);
                    facturasCopy.push(facturas[ks]);
                }
            });
            let check=[];
            let checksOtroValor=[];
            let checksValor1=[];
            let checksValor2=[];
            let checksValor3=[];
            let valuesOtroValor=[];
            let validarFecha=[];
            let posicionInfo=0;
            let session=false;
            let visibleIva=false;
            if(sessionStorage.getItem("check")){
                check=JSON.parse(sessionStorage.getItem("check"));
                checksOtroValor =JSON.parse(sessionStorage.getItem("checksOtroValor"));
                checksValor1=JSON.parse(sessionStorage.getItem("checksValor1"));
                checksValor2=JSON.parse(sessionStorage.getItem("checksValor2"));
                checksValor3=JSON.parse(sessionStorage.getItem("checksValor3"));
                valuesOtroValor=JSON.parse(sessionStorage.getItem("valuesOtroValor"));
                check.forEach((c)=>{
                    if(c)session=true;
                })

                checksOtroValor.forEach((c)=>{
                    if(c)session=true;
                })

                checksValor1.forEach((c)=>{
                    if(c)session=true;
                })

                checksValor2.forEach((c)=>{
                    if(c)session=true;
                })

                checksValor3.forEach((c)=>{
                    if(c)session=true;
                })

                if(checksOtroValor>facturas.length){
                    checksOtroValor=[];
                    checksValor1=[];
                    checksValor2=[];
                    checksValor3=[];
                    valuesOtroValor=[];
                    key.forEach((it,k)=>{
                        if(k<=facturas.length){
                            checksOtroValor.push(checksOtroValor[k]);
                            checksValor1.push(checksValor1[k]);
                            checksValor2.push(checksValor2[k]);
                            checksValor3.push(checksValor3[k]);
                            valuesOtroValor.push(valuesOtroValor[k]);
                        }
                    });
                }

            }

            let info = JSON.parse(sessionStorage.getItem("informacion"));

            let infoFactura = [];

            fact.forEach((fac, i) => {
                idCheckout += `${String(fact[i]["id"])}${
                    i === fact.length - 1 ? "" : ":"
                }`;
            })
            configCampos.map((conf, kconf) => {
                fact.forEach((fac, i) => {
                    let data = {};

                    Object.keys(fac).forEach((k) => {
                        if (k === conf.tipoCampo && conf.visible) {
                            data["titulo"] = conf.nombreCampo;
                            data["ayuda"] = conf.textoAyuda;
                            data["entidad"] = conf.tipoCampo;
                            data["checked"] = false;
                            data["password"] = conf.configCampo == "password" ? true : false;
                            data["tipo_campo_2"] = conf.tipo_campo_2;
                            data["moneda"] = fact[0]["moneda"];
                            if (
                                conf.tipoCampo === "total" ||
                                conf.tipoCampo === "segundoTotal" ||
                                conf.tipoCampo === "tercerTotal"
                            ) {
                                entidadValor = k;

                                if(!idCheckout.includes(String(fact[i]["id"]))){
                                    idCheckout += `${String(fact[i]["id"])}${
                                        i === fact.length - 1 ? "" : ":"
                                    }`;
                                }

                                data["valor"] = `$ ${parseFloat(
                                    fac[k]
                                ).toLocaleString("en-US", { minimumFractionDigits: 0 })} ${
                                    opcionesRecaudo.moneda.value
                                }`;
                                data["valorReal"] = fac[k];
                                if (session) {
                                    if (checksValor1[key[i]] && k === "total") {
                                        if (fac["iva"] && fac["iva"] !== null) {
                                            iva = fac["iva"];
                                        }
                                        if (fac["fechaExpiracion"])
                                            validarFecha.push("fechaExpiracion");
                                        abonos.push(null);
                                        opcionPago.push(k);
                                        total += fac["total"];
                                        let splitIdCheckout = valorCheckout.split(":");
                                        if(splitIdCheckout.length<fact.length || splitIdCheckout[splitIdCheckout.length-1]=="") {
                                            objectValorCheckout = { ...objectValorCheckout, [i]: String(fac["total"])}
                                        }
                                        data["valor"] = `$ ${parseFloat(
                                            fac["total"]
                                        ).toLocaleString("en-US", {
                                            minimumFractionDigits: 0
                                        })} ${opcionesRecaudo.moneda.value}`;
                                    }

                                    if (checksValor2[key[i]] && k === "segundoTotal") {
                                        if (fac["segundoIva"] && fac["segundoIva"] !== null) {
                                            iva = fac["segundoIva"];
                                        }
                                        if (fac["segundaFechaVencimiento"])
                                            validarFecha.push("segundaFechaVencimiento");
                                        abonos.push(null);
                                        opcionPago.push(k);
                                        total += fac["segundoTotal"];
                                        let splitIdCheckout = valorCheckout.split(":");
                                        if(splitIdCheckout.length<fact.length || splitIdCheckout[splitIdCheckout.length-1]=="") {
                                            objectValorCheckout = { ...objectValorCheckout, [i]: String(fac["segundoTotal"])}
                                        }
                                        data["valor"] = `$ ${parseFloat(
                                            fac["segundoTotal"]
                                        ).toLocaleString("en-US", {
                                            minimumFractionDigits: 0
                                        })} ${opcionesRecaudo.moneda.value}`;
                                    }

                                    if (checksValor3[key[i]] && k === "tercerTotal") {
                                        if (fac["tercerIva"] && fac["tercerIva"] !== null) {
                                            iva = fac["tercerIva"];
                                        }
                                        if (fac["tercerFechaVencimiento"])
                                            validarFecha.push("tercerFechaVencimiento");
                                        abonos.push(null);
                                        opcionPago.push(k);
                                        total += fac["tercerTotal"];
                                        let splitIdCheckout = valorCheckout.split(":");
                                        if(splitIdCheckout.length<fact.length || splitIdCheckout[splitIdCheckout.length-1]=="") {
                                            objectValorCheckout = { ...objectValorCheckout, [i]: String(fac["tercerTotal"])}
                                        }
                                        data["valor"] = `$ ${parseFloat(
                                            fac["tercerTotal"]
                                        ).toLocaleString("en-US", {
                                            minimumFractionDigits: 0
                                        })} ${opcionesRecaudo.moneda.value}`;
                                    }

                                    if (checksOtroValor[key[i]]) {
                                        if (
                                            k === "total" &&
                                            fact[i]["iva"] &&
                                            fact[i]["iva"] !== null
                                        ) {
                                            iva =
                                                (fact[i]["iva"] / fact[i]["total"]) *
                                                valuesOtroValor[key[i]];
                                        } else if (
                                            k === "segundoTotal" &&
                                            fact[i]["segundoIva"] &&
                                            fact[i]["segundoIva"] !== null
                                        ) {
                                            iva =
                                                (fact[i]["segundoIva"] / fact[i]["segundoTotal"]) *
                                                valuesOtroValor[key[i]];
                                        } else if (
                                            k === "tercerTotal" &&
                                            fact[i]["tercerIva"] &&
                                            fact[i]["tercerIva"] !== null
                                        ) {
                                            iva =
                                                (fact[i]["tercerIva"] / fact[i]["tercerTotal"]) *
                                                valuesOtroValor[key[i]];
                                        }

                                        if (k === "total" && fact[i]["fechaExpiracion"]) {
                                            validarFecha.push("fechaExpiracion");
                                        } else if (
                                            k === "segundoTotal" &&
                                            fact[i]["segundaFechaVencimiento"]
                                        ) {
                                            validarFecha.push("segundaFechaVencimiento");
                                        } else if (
                                            k === "tercerTotal" &&
                                            fact[i]["tercerFechaVencimiento"]
                                        ) {
                                            validarFecha.push("tercerFechaVencimiento");
                                        }

                                        if(i === abonos.length){
                                            abonos.push(valuesOtroValor[key[i]]);
                                            opcionPago.push("abono");
                                            total += valuesOtroValor[key[i]];
                                        }
                                        aux = true;
                                        let splitIdCheckout = valorCheckout.split(":");
                                        if(splitIdCheckout.length<fact.length || splitIdCheckout[splitIdCheckout.length-1]=="") {
                                            objectValorCheckout = { ...objectValorCheckout, [i]: String(valuesOtroValor[key[i]])}
                                        }
                                    }
                                } else {
                                    if (k === "total") {
                                        let splitIdCheckout = valorCheckout.split(":");
                                        if(splitIdCheckout.length<fact.length || splitIdCheckout[splitIdCheckout.length-1]==""){
                                            objectValorCheckout = { ...objectValorCheckout, [i]: String(fac["total"])}
                                        }
                                        if (fac["iva"] && fac["iva"] !== null) {
                                            iva = fac["iva"];
                                        }
                                    } else if ("segundoTotal") {
                                        let splitIdCheckout = valorCheckout.split(":");
                                        if(splitIdCheckout.length<fact.length || splitIdCheckout[splitIdCheckout.length-1]==""){
                                            objectValorCheckout = { ...objectValorCheckout, [i]: String(fac["segundototal"])}
                                        }
                                        if (fac["segundoIva"] && fac["segundoIva"] !== null) {
                                            iva = fac["segundoIva"];
                                        }
                                    } else if ("tercerTotal") {
                                        let splitIdCheckout = valorCheckout.split(":");
                                        if(splitIdCheckout.length<fact.length || splitIdCheckout[splitIdCheckout.length-1]==""){
                                            objectValorCheckout = { ...objectValorCheckout, [i]: String(fac["tercerTotal"])}
                                        }
                                        if (fac["tercerIva"] && fac["tercerIva"] !== null) {
                                            iva = fac["tercerIva"];
                                        }
                                    }

                                    if (k === "total" && fact[i]["fechaExpiracion"]) {
                                        validarFecha.push("fechaExpiracion");
                                    } else if (
                                        k === "segundoTotal" &&
                                        fact[i]["segundaFechaVencimiento"]
                                    ) {
                                        validarFecha.push("segundaFechaVencimiento");
                                    } else if (
                                        k === "tercerTotal" &&
                                        fact[i]["tercerFechaVencimiento"]
                                    ) {
                                        validarFecha.push("tercerFechaVencimiento");
                                    }

                                    abonos.push(null);
                                    opcionPago.push(k);
                                    total += fac[k];
                                    data["valor"] = `$ ${parseFloat(
                                        fac[k]
                                    ).toLocaleString("en-US", { minimumFractionDigits: 0 })} ${
                                        opcionesRecaudo.moneda.value
                                    }`;
                                }
                                moneda = opcionesRecaudo.moneda.value;
                            } else if (
                                conf.tipoCampo === "iva" ||
                                conf.tipoCampo === "segundoIva" ||
                                conf.tipoCampo === "tercerIva"
                            ) {
                                visibleIva = true;
                                data["valor"] = `$ ${parseFloat(
                                    fac[k]
                                ).toLocaleString("en-US", { minimumFractionDigits: 0 })} ${
                                    opcionesRecaudo.moneda.value
                                }`;

                            } else {
                                data["valor"] = data["password"] ? '********' : fac[k];
                            }
                        }
                        else if (k === conf.tipoCampo) {
                            visibleIva = false;
                            if (k === "total" && conf.visible) {
                                if (fac["fechaExpiracion"])
                                    validarFecha.push("fechaExpiracion");
                            }
                            else if (k === "segundoTotal" && conf.visible) {
                                validarFecha.push("segundaFechaVencimiento" && conf.visible);
                            }
                            else if (k === "tercerTotal" && conf.visible) {
                                validarFecha.push("tercerFechaVencimiento");
                            }
                        }
                    });
                    if (Object.keys(data).length > 0) {
                        infoFactura.push(data);
                    }
                });
            });

            if (entidadIva !== "" && entidadValor !== "") {

                if (visibleIva) {
                    infoFactura[posicionInfo]["valor"] = `$ ${parseFloat(
                        iva
                    ).toLocaleString("en-US", { minimumFractionDigits: 0 })} ${
                        fact[0]["moneda"]
                    }`;
                }
            }
            if (fact.length > 1) {
                let key = [];
                infoFactura.forEach((ifo, k) => {

                    configCampos.forEach((f, k2) => {
                        if (f.nombreCampo === ifo.titulo && (f.tipoCampo === "total" || f.tipoCampo === "segundoTotal" || f.tipoCampo === "tercerTotal")) {
                            key.push(k);
                        }
                    })
                })
                let auxDelete = 0;
                key.forEach(k => {
                    infoFactura.splice(k - auxDelete, 1);
                    auxDelete++;
                })
                infoFactura.push({
                    titulo: "Total a pagar",
                    ayuda: "",
                    valor: `$ ${parseFloat(total).toLocaleString("en-US", {
                    })} ${fact[0]["moneda"]}`
                });
            }
            //Validar si las opciones de recaudo tiene multiples valores para pago

            if (fact.length === 1) {
                let checksOtroValorV=JSON.parse(sessionStorage.getItem("facturaPagar"));

                if(typeof checksOtroValorV ==="object"){
                    if(checksOtroValor[checksOtroValorV[0]]){
                        infoFactura.push({
                            titulo: "Otro valor",
                            ayuda: "Otro valor a pagar",
                            valor: `$ ${parseFloat(valuesOtroValor[parseInt(checksOtroValorV[0])]).toLocaleString("en-US", {
                                minimumFractionDigits: 0
                            })} ${fact[0]["moneda"]}`
                        })

                        valorCheckout = parseFloat(valuesOtroValor[parseInt(checksOtroValorV[0])]);
                        total = parseFloat(valuesOtroValor[parseInt(checksOtroValorV[0])]);
                    }
                }else{
                    if(checksOtroValor[checksOtroValorV]){
                        infoFactura.push({
                            titulo: "Otro valor",
                            ayuda: "Otro valor a pagar",
                            valor: `$ ${parseFloat(valuesOtroValor[parseInt(checksOtroValorV)]).toLocaleString("en-US", {
                                minimumFractionDigits: 0
                            })} ${fact[0]["moneda"]}`
                        })

                        valorCheckout = parseFloat(valuesOtroValor[parseInt(checksOtroValorV)]);
                        total = parseFloat(valuesOtroValor[parseInt(checksOtroValorV)]);
                    }
                }
            }
            if(facturasCopy.length > 1){
                infoFactura = infoFactura.map(el =>{
                    return {
                        ...el,
                        valor: this.FormatoCampo(el)
                    }
                })
                let infoFactura2 = [...infoFactura];
                for (let index = 0; index < facturasCopy.length; index++) {
                    const factura_keys = Object.keys(facturasCopy[index]);
                    for (const factura_key of factura_keys) {
                        const search = infoFactura2.find(el => el.entidad == factura_key)
                        if(search){
                            const indexSearch = infoFactura2.findIndex(el => el.entidad == factura_key)
                            infoFactura2.splice(indexSearch, 1)
                            facturasCopy[index][factura_key] = search.valor;
                        }
                    }
                }
            }
            this.setState({
                fechasValidacion: validarFecha,
                infoFactura,
                infoCabecera,
                infoEmpresa: info,
                configuracionCampos:configCampos,
                total,
                moneda,
                iva,
                abonos,
                opcionPago,
                copiaOpcionPago: [...opcionPago],
                objectValor: objectValorCheckout,
                facturasCheckout: `id:${idCheckout}:valor:${Object.values(objectValorCheckout).join(':')}`,
                facturas: facturasCopy
            },()=>{
                let openAutomatic=JSON.parse(sessionStorage.getItem("autoCheckout"));
                if(openAutomatic)this.openCheckoutAutomatic();
            });
        } else {
            this.props.openModal("Factura no encontrada.", "danger");
            this.props.history.push(ruta.home);
        }
    }

    openCheckoutAutomatic(){
        this.crearFactura();
    }

    crearFactura(){
        this.setState({
            loading:true,
        },()=>this.openCheckout(sessionStorage.getItem("log")))
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (Object.keys(nextProps).length > 0 && nextProps.info) {
            this.setState({
                infoEmpresa: nextProps.info
            });
        }
    }

    showAlert(type = 'info', isDelay = false, message = ''){
        this.setState({
            showMessage: {
                open: true,
                type: type,
                isDelay: isDelay,
                message : message
            }
        }, () =>{
            if(isDelay){
                setTimeout(function(){
                    this.setState({
                        showMessage:{
                            open: false,
                            type: 'info',
                            isDelay: false,
                            message : ''
                        },
                    })
                }, 5000);
            }
        })
    }

    closedAlert(){
        this.setState({
            showMessage:{
                open: false,
                type: 'info',
                isDelay: false,
                message : ''
            },
        })
    }

    openCheckout(idFactura) {

        let confirmUrl = process.env.REACT_APP_URL_CONFIRMACION;
        let responseUrl = `${window.location.protocol}//${window.location.hostname}${ruta.respuesta}`;

        if (process.env.REACT_APP_SERVER_RESPONSE === "true") {
            responseUrl = `${process.env.REACT_APP_SERVER}${ruta.respuesta}`;
        }

        let facturasPagar = JSON.parse(sessionStorage.getItem("facturaPagar"));
        facturasPagar = facturasPagar.length > 0 ? facturasPagar.length : 1;

        let total = parseFloat(this.state.total);
        let subtotal = total - parseFloat(this.state.iva);

        let data = {
            //Parametros compra (obligatorio)
            name: `${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`,
            description: `${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`,
            // invoice: String(idFactura),
            currency: this.state.moneda,
            amount: total,
            tax_base: this.state.iva === 0 ? "0" : String(subtotal),
            tax: this.state.iva === 0 ? "0" : String(total - subtotal),
            country: "co",
            lang: "es",

            //Onpage="false" - Standard="true"
            external: "false",

            //Atributos opcionales
            // extra1: "extra1",
            // extra2: "extra2",
            // extra3: "extra3",
            extra9:"online",
            extra10: this.state.facturasCheckout,
            confirmation: confirmUrl,
            response: responseUrl

            //Atributos cliente
            // name_billing: "Andres Perez",
            // address_billing: "Carrera 19 numero 14 91",
            // type_doc_billing: "cc",
            // mobilephone_billing: "3050000000",
            // number_doc_billing: "100000000"
        };
        let facturasSession = JSON.parse(sessionStorage.getItem("facturas"));

        if(this.state.opcionesRecaudo != "" &&
            this.state.opcionesRecaudo &&
            this.state.opcionesRecaudo.modificarValorPagar.activo
        ){
            let optionValue = null;
            let modificarValor = this.state.opcionesRecaudo.modificarValorPagar
            let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
            if(modificarValor.value){
                optionValue = modificarValor.value;
            }


            switch (modificarValor.opcion) {
                case '<':

                    if(optionValue){
                        if(optionValue.maxType == "ePayco"){
                            let maxVal = 8000000;
                            let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                            if(campo){
                                if(this.state.infoFactura && this.state.infoFactura.length > 0){
                                    let info = this.state.infoFactura.find(val => val.entidad == campo.tipoCampo);
                                    if(info){
                                        maxVal = typeof info.valor == "string" ?
                                                    parseInt(info.valor.match(/\d/g).join("")) :
                                                        info.valor;
                                    }
                                }
                            }
                            if(parseInt(total) > maxVal || parseInt(total) <= 0){
                                toast.warn(
                                    `Solo estan permitidos valores inferiores al valor máximo ($${maxVal})`
                                );
                                return 0;
                            }else{
                                this.closedAlert();
                            }
                        }else{
                            if(parseInt(total) > (optionValue.maxVal * facturasPagar) || parseInt(total) <= 0){
                                toast.warn(
                                    `Solo estan permitidos valores inferiores al valor máximo ($${(optionValue.maxVal * facturasPagar)})`
                                );
                                return 0;
                            }else{
                                this.closedAlert();
                            }
                        }
                    }
                    break;
                case '>':
                    if(optionValue){
                        if(optionValue.minType == "ePayco"){
                            let minVal = 1;
                            let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                            if(campo){
                                if(this.state.infoFactura && this.state.infoFactura.length > 0){
                                    let info = this.state.infoFactura.find(val => val.entidad == campo.tipoCampo);
                                    if(info){
                                        minVal = typeof info.valor == "string" ?
                                                    parseInt(info.valor.match(/\d/g).join("")) :
                                                        info.valor;
                                    }
                                }
                            }
                            if(parseInt(total) < minVal || parseInt(total) <= 0){
                                toast.warn(
                                    `Solo estan permitidos valores superiores al valor mínimo ($${minVal})`
                                );
                                return 0;
                            }else{
                                this.closedAlert();
                            }
                        }else{
                            if(parseInt(total) < (optionValue.minVal * facturasPagar) || parseInt(total) <= 0){
                                toast.warn(
                                    `Solo estan permitidos valores superiores al valor mínimo ($${optionValue.minVal})`
                                );
                                return 0;
                            }else{
                                this.closedAlert();
                            }
                        }
                    }
                    break;
                case '<>':
                    if(optionValue){
                        let minVal = optionValue.minVal ? optionValue.minVal : 1 ;
                        let maxVal = optionValue.maxVal ? optionValue.maxVal : 8000000 ;
                        if(optionValue.minType == "ePayco"){
                            let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                            if(campo){
                                if(this.state.infoFactura && this.state.infoFactura.length > 0){
                                    let info = this.state.infoFactura.find(val => val.entidad == campo.tipoCampo);
                                    if(info){
                                        minVal = typeof info.valor == "string" ?
                                                    parseInt(info.valor.match(/\d/g).join("")) :
                                                        info.valor;
                                    }
                                }
                            }
                        }

                        if(optionValue.maxType == "ePayco"){
                            let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                            if(campo){
                                if(this.state.infoFactura && this.state.infoFactura.length > 0){
                                    let info = this.state.infoFactura.find(val => val.entidad == campo.tipoCampo);

                                    if(info){
                                        maxVal = typeof info.valor == "string" ?
                                                    parseInt(info.valor.match(/\d/g).join("")) :
                                                        info.valor;
                                    }
                                }
                            }
                        }

                        if(parseInt(total) < (minVal * facturasPagar) || parseInt(total) > (maxVal * facturasPagar)){
                            this.showAlert('info', false, `Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`)
                            toast.warn(
                                `Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`
                            );
                            return 0;
                        }else{
                            this.closedAlert();
                        }
                    }
                    break;
                default:
                    this.closedAlert()
            }
        }

        if (
            this.state.opcionesRecaudo != "" &&
            this.state.opcionesRecaudo &&
            this.state.opcionesRecaudo.multiplesValoresPago.activo &&
            facturasSession.length <= 1
        ) {
            let activo = this.state.infoFactura.filter(infoF => {
                if (infoF.checked) {
                    if (infoF.entidad === "total" && this.state.facturas[0]["iva"]) {
                        let subtotal = total - this.state.facturas[0]["iva"];
                        data.tax_base =
                            this.state.facturas[0]["iva"] === 0 ? "0" : String(subtotal);
                        data.tax =
                            this.state.facturas[0]["iva"] === 0
                                ? "0"
                                : String(total - subtotal);
                    }
                    if (
                        infoF.entidad === "segundoTotal" &&
                        this.state.facturas[0]["segundoIva"]
                    ) {
                        let subtotal = total - this.state.facturas[0]["segundoIva"];
                        data.tax_base =
                            this.state.facturas[0]["segundoIva"] === 0
                                ? "0"
                                : String(subtotal);
                        data.tax =
                            this.state.facturas[0]["segundoIva"] === 0
                                ? "0"
                                : String(total - subtotal);
                    }
                    if (
                        infoF.entidad === "tercerTotal" &&
                        this.state.facturas[0]["tercerIva"]
                    ) {
                        let subtotal = total - this.state.facturas[0]["tercerIva"];
                        data.tax_base =
                            this.state.facturas[0]["tercerIva"] === 0
                                ? "0"
                                : String(subtotal);
                        data.tax =
                            this.state.facturas[0]["tercerIva"] === 0
                                ? "0"
                                : String(total - subtotal);
                    }
                }
                return infoF.checked;
            });
            if (
                (activo && activo.length > 0) ||
                (this.state.opcionPago && this.state.opcionPago.length > 0
                    ? this.state.opcionPago[0] : "") === "abono"
            ) {
                this.checkout(data);
            } else {
                toast.warn(
                    "Debe seleccionar por lo menos un valor para realizar el pago"
                );
            }
        }
        else {
            this.checkout(data);
        }
    }

    checkout(data) {

        this.setState({loading: true});
        // console.log("ESTOY AQUI:::", this.state)
        // console.log("ESTOY AQUI2:::", data)
        if (this.state.cambioValor) {
            let optionValue = null;
            let modificarValor = this.state.opcionesRecaudo.modificarValorPagar;
            let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
            if(modificarValor){
                optionValue = modificarValor.value;
            }
            if(optionValue){
                switch (modificarValor.opcion) {
                    case '<':
                        if(optionValue.maxType == "ePayco"){
                            let maxVal = 8000000;
                            let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                            if(campo){
                                if(this.state.infoFactura && this.state.infoFactura.length > 0){
                                    let info = this.state.infoFactura.find(val => val.entidad == campo.tipoCampo);
                                    if(info){
                                        maxVal = typeof info.valor == "string" ?
                                                    parseInt(info.valor.match(/\d/g).join("")) :
                                                        info.valor;
                                    }
                                }
                            }
                            if(parseInt(data.amount) > maxVal || parseInt(data.amount) <= 0){
                                toast.warn(
                                    `Solo estan permitidos valores inferiores al valor máximo ($${maxVal})`
                                );
                                return 0;
                            }else{
                                window.ePayco.checkout
                                    .configure({
                                        key: parseJwt(),
                                        test: sessionStorage.getItem("test")
                                    })
                                    .open(data);
                                this.setState({
                                    loading: false
                                })
                            }
                        }else{
                            if(parseInt(data.amount) > optionValue.maxVal || parseInt(data.amount) <= 0){
                                toast.warn(
                                    `Solo estan permitidos valores inferiores al valor máximo ($${optionValue.maxVal})`
                                );
                                return 0;
                            }else{
                                window.ePayco.checkout
                                    .configure({
                                        key: parseJwt(),
                                        test: sessionStorage.getItem("test")
                                    })
                                    .open(data);
                                this.setState({
                                    loading: false
                                })
                            }
                        }
                        break;
                    case '>':
                        if(optionValue.minType == "ePayco"){
                            let minVal = 1;
                            let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                            if(campo){
                                if(this.state.infoFactura && this.state.infoFactura.length > 0){
                                    let info = this.state.infoFactura.find(val => val.entidad == campo.tipoCampo);
                                    if(info){
                                        minVal = typeof info.valor == "string" ?
                                                    parseInt(info.valor.match(/\d/g).join("")) :
                                                        info.valor;
                                    }
                                }
                            }
                            if(parseInt(data.amount) < minVal || parseInt(data.amount) <= 0){
                                toast.warn(
                                    `Solo estan permitidos valores superiores al valor mínimo ($${minVal})`
                                );
                                return 0;
                            }else{
                                window.ePayco.checkout
                                    .configure({
                                        key: parseJwt(),
                                        test: sessionStorage.getItem("test")
                                    })
                                    .open(data);
                                this.setState({
                                    loading: false
                                })
                            }
                        }else{
                            if(parseInt(data.amount) < optionValue.minVal || parseInt(data.amount) <= 0){
                                toast.warn(
                                    `Solo estan permitidos valores superiores al valor mínimo ($${optionValue.minVal})`
                                );
                                return 0;
                            }else{
                                window.ePayco.checkout
                                    .configure({
                                        key: parseJwt(),
                                        test: sessionStorage.getItem("test")
                                    })
                                    .open(data);
                                this.setState({
                                    loading: false
                                })
                            }
                        }
                        break;
                    case '<>':
                        let minVal = optionValue.minVal ? optionValue.minVal : 1 ;
                        let maxVal = optionValue.maxVal ? optionValue.maxVal : 8000000 ;
                        if(optionValue.minType == "ePayco"){
                            let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                            if(campo){
                                if(this.state.infoFactura && this.state.infoFactura.length > 0){
                                    let info = this.state.infoFactura.find(val => val.entidad == campo.tipoCampo);
                                    if(info){
                                        minVal = typeof info.valor == "string" ?
                                                    parseInt(info.valor.match(/\d/g).join("")) :
                                                        info.valor;
                                    }
                                }
                            }
                        }

                        if(optionValue.maxType == "ePayco"){
                            let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                            if(campo){
                                if(this.state.infoFactura && this.state.infoFactura.length > 0){
                                    let info = this.state.infoFactura.find(val => val.entidad == campo.tipoCampo);

                                    if(info){
                                        maxVal = typeof info.valor == "string" ?
                                                    parseInt(info.valor.match(/\d/g).join("")) :
                                                        info.valor;
                                    }
                                }
                            }
                        }

                        if(parseInt(data.amount) < minVal || parseInt(data.amount) > maxVal){
                            this.showAlert('info', false, `Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`)
                            toast.warn(
                                `Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`
                            );
                            return 0;
                        }else{
                            window.ePayco.checkout
                                .configure({
                                    key: parseJwt(),
                                    test: sessionStorage.getItem("test")
                                })
                                .open(data);
                            this.setState({
                                loading: false
                            })
                        }
                        break;
                    default:
                        window.ePayco.checkout
                        .configure({
                            key: parseJwt(),
                            test: sessionStorage.getItem("test")
                        })
                        .open(data);
                    this.setState({
                        loading: false
                    })
                }
            }else{
                if ((this.state.pagoMinimo > data.amount) && this.state.opcionesRecaudo.modificarValorPagar.activo && this.state.opcionesRecaudo.modificarValorPagar.opcion === ">") {
                    toast.warn(
                        `No supera el valor mínimo (${this.state.pagoMinimoMoneda}) permitido a pagar de la factura`
                    );
                    this.setState({
                        loading: false
                    })
                } else if ((this.state.pagoMinimo < data.amount) && this.state.opcionesRecaudo.modificarValorPagar.activo && this.state.opcionesRecaudo.modificarValorPagar.opcion === "<") {
                    toast.warn(
                        `Supera el valor máximo (${this.state.pagoMinimoMoneda}) permitido a pagar de la factura`
                    );
                    this.setState({
                        loading: false
                    })
                } else if (data.amount === 0) {
                    toast.warn(
                        "No supera el valor mínimo permitido a pagar de la factura"
                    );
                    this.setState({
                        loading: false
                    })
                } else {
                    window.ePayco.checkout
                        .configure({
                            key: parseJwt(),
                            test: sessionStorage.getItem("test")
                        })
                        .open(data);
                    this.setState({
                        loading: false
                    })
                }
            }
        }
        else {
            let self = this;
            let handler =   window.ePayco.checkout
                .configure({
                    key: parseJwt(),
                    test: sessionStorage.getItem("test"),
                });
                handler.onClosed(function(){
                    self.setState({ loading: false })
                })
                handler.open(data);
        }
    }


    handleChangeRadio(e) {
        let value = e.target.value;
        let entidad = e.target.name;
        let abonos = [];
        let opcionPago = [];
        let infoFactura = this.state.infoFactura;
        let extra10 = this.state.facturasCheckout.split("valor")[0];
        let newInfo = infoFactura.map((item, key) => {
            if (
                item.entidad === "total" ||
                item.entidad === "segundoTotal" ||
                item.entidad === "tercerTotal"
            ) {
                if (item.entidad === entidad) {
                    opcionPago.push(entidad);
                    abonos.push(null);
                    item.checked = true;
                    this.setState({
                        otroValorChecked: false
                    });
                } else {
                    item.checked = false;
                }
            }
            return item;
        });
        if (entidad === "otro") {
            opcionPago.push("abono");
            abonos.push(value);
            this.setState({
                otroValorChecked: !this.state.otroValorChecked,
                cambioValor: true
            });
        }
        extra10 += `valor:${value}`;
        this.setState({
            infoFactura: newInfo,
            facturasCheckout: extra10,
            total: value,
            opcionPago,
            abonos
        });
    }

    downloadPdf() {

        let abonos = Object.assign(this.state.abonos);
        if(this.state.otroValor > 0){
            abonos[0] = this.state.otroValor;
        }
        
        const data = {
            param: JSON.parse(sessionStorage.getItem("param")),
            informacion: JSON.parse(sessionStorage.getItem("informacion")),
            busqueda: JSON.parse(sessionStorage.getItem("configCampos")),
            facturas: JSON.parse(sessionStorage.getItem("facturas")),
            abonos: abonos,
            opcionPago: this.state.opcionPago,
            fechaFactura: JSON.parse(sessionStorage.getItem("fechaActualizacion")),
            total: sessionStorage.getItem("total"),
            facturaPagar: sessionStorage.getItem("facturaPagar")
                ? JSON.parse(sessionStorage.getItem("facturaPagar"))
                : [0]
        };

        this.setState({loadingDownload: true});
        serviceApiResponse(data, api.exportar, "POST")
            .then(response => {
                if (response.success) {
                    const contentType = response.data.contentType;
                    const b64Data = response.data.ruta;

                    const blob = b64toBlob(b64Data, contentType);
                    const blobUrl = URL.createObjectURL(blob);

                    let element = document.getElementById("pdf");
                    element.setAttribute("href", blobUrl);
                    element.setAttribute("download", response.data.nombre);
                    element.click();
                }
                this.setState({loadingDownload: false});
            })
            .catch(error => {
                this.setState({loadingDownload: false});
            });
    }

    changeOtroValor(value, name) {
        let extra10 = this.state.facturasCheckout.split("valor")[0];


        if(this.state.opcionesRecaudo.decimal && value){
            if(this.state.opcionesRecaudo.decimal.value != "none"){
                value = Number(value.replace(/[^0-9.]+/g,""));
            }else{
                value = Number(value.replace(/[^0-9]+/g,""));
            }
        }else{
            value = Number(value.replace(/[^0-9]+/g,""));
        }

        extra10 += `valor:${value}`;


        if (this.state.opcionesRecaudo.modificarValorPagar.opcion !== "!=") {
            let valores = [];
            let valoresMoneda = [];

            this.state.infoFactura.filter((infoFac, key) => {
                if (infoFac.entidad === "total" || infoFac.entidad === "segundoTotal" || infoFac.entidad === "tercerTotal") {
                    valores.push(infoFac.valorReal);
                    valoresMoneda.push(infoFac.valor);
                }
            })

            let valorMaximo = valores[0];
            let valorMaximoMoneda = valoresMoneda[0];
            let valorMinimo = valores[0];
            for (let i = 1; i < valores.length; i++) {
                if (valores[i]) {
                    if (valorMaximo < valores[i]) {
                        valorMaximo = valores[i];
                        valorMaximoMoneda = valoresMoneda[i];
                    }

                    if (valorMinimo > valores[i]) {
                        valorMinimo = valores[i];
                    }
                }
            }
            if (this.state.opcionesRecaudo.modificarValorPagar.opcion === "<" && value > valorMaximo) {
                this.setState({
                    total: parseFloat(value),
                    otroValor: parseFloat(value),
                    facturasCheckout: this.state.facturasCheckout,
                });
            }




            if (this.state.opcionesRecaudo.modificarValorPagar.opcion === ">" && value < valorMinimo) {
                this.setState({
                    total: parseFloat(value),
                    otroValor: parseFloat(value),
                    facturasCheckout: this.state.facturasCheckout,
                });
            } else {
                this.setState({
                    total: parseFloat(value),
                    otroValor: parseFloat(value),
                    facturasCheckout: extra10,
                    cambioValor: true,
                    pagoMinimo:valorMaximo,
                    pagoMinimoMoneda:valorMaximoMoneda
                });
            }
        } else {
            this.setState({
                total: parseFloat(value),
                otroValor: parseFloat(value),
                facturasCheckout: extra10
            });
        }


    }
    FormatoCampo(Inf){
        let valor = "";
        switch (Inf.tipo_campo_2) {
            case 'moneda':
                valor = `$ ${parseFloat(Inf.valor).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                })} ${Inf.moneda}`;
                break;
            case 'numerico':
                valor = parseFloat(Inf.valor).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                });
                break;
            case 'porcentaje':
                valor = `${parseFloat(Inf.valor).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                })} %`;
                break;
            default:
                valor = Inf.valor
                break;
        }
        return valor;
    }
    render() {
        let facturas = JSON.parse(sessionStorage.getItem("facturas"));
        let opcionesRecaudo =
            JSON.parse(sessionStorage.getItem("opcionesRecaudo")) ||
            this.state.opcionesRecaudo;
        if (
            opcionesRecaudo != "" &&
            opcionesRecaudo &&
            opcionesRecaudo.multiplesValoresPago.activo &&
            facturas.length === 1
        ) {
            return (
                <Elastic
                    felx={"1 0 auto"}
                    className={"wc cambio "}
                    css={css`
            animation: ${Transition} 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 1;
          `}
                >
                    <Mycard
                        title={`${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`}
                        back={
                            facturas && facturas.length > 1
                                ? sessionStorage.getItem("facturaPagar")
                                ? ruta.facturas
                                : ruta.home
                                : ruta.home
                        }
                        className={" col-12 col-lg-10 col-xl-7 mx-auto px-0"}
                        footer={this.state.infoEmpresa.mostrarDatos == 1 && <FooterFactura info={this.state.infoEmpresa}/>}
                        history={this.props.history}
                        visible
                    >
                        <div className="wc">
                            <CustomizedSnackbars
                                message={this.state.showMessage.message}
                                type={'info'}
                                visible={this.state.showMessage.open}
                                isClosed={true}
                                onClose={this.closedAlert}
                            />
                            <div className="col-12 pb-3">
                                <Flex jc={"space-between"} className={"py-1 px-3"}>
                                    <b className={"cg"}>Descripción</b>
                                    <Line dotted className={"wc"}/>
                                </Flex>

                                {this.state.infoFactura.map((inf, key) => {
                                    return inf.entidad === "total" ||
                                    inf.entidad === "segundoTotal" ||
                                    inf.entidad === "tercerTotal" ? (
                                        <div>
                                            <Flex
                                                jc={"space-between"}
                                                className={"py-1 px-3"}
                                                key={`inf-${key}`}
                                            >
                                                {inf.ayuda !== "" && (
                                                    <ReactTooltip
                                                        id={`help-${key}`}
                                                        place="right"
                                                        type="info"
                                                        effect="solid"
                                                    >
                                                        {inf.ayuda}
                                                    </ReactTooltip>
                                                )}
                                                <small data-tip data-for={`help-${key}`}>
                                                    {inf.entidad != "facturaId" && (
                                                        <MyRadio
                                                            color="primary"
                                                            value={inf.valorReal}
                                                            checked={inf.checked}
                                                            name={inf.entidad}
                                                            onChange={this.handleChangeRadio.bind(this)}
                                                        />
                                                    )}
                                                    <b>{inf.titulo}</b>
                                                </small>
                                                <small className={"mb-0 cg"}>{inf.valor}</small>
                                                <Line dotted className={"wc"}/>
                                            </Flex>
                                            {
                                                key === this.state.infoFactura.length - 1 &&
                                                opcionesRecaudo &&
                                                opcionesRecaudo.modificarValorPagar.activo && (
                                                    <Flex
                                                        jc={"space-between"}
                                                        className={"py-1 px-3"}
                                                        key={`inf-${key}`}
                                                    >
                                                        {opcionesRecaudo &&
                                                        opcionesRecaudo.modificarValorPagar.activo && (
                                                            <ReactTooltip
                                                                id={`help-${key}`}
                                                                place="right"
                                                                type="info"
                                                                effect="solid"
                                                            >
                                                                {opcionesRecaudo.modificarValorPagar.opcion === "<"
                                                                    ? "Editar el valor de la factura por un valor igual o inferior"
                                                                    : opcionesRecaudo.modificarValorPagar.opcion ===
                                                                    ">"
                                                                        ? "Editar el valor de la factura por un valor igual o superior"
                                                                        : "Editar el valor a pagar de la factura"}
                                                            </ReactTooltip>
                                                        )}
                                                        <small data-tip data-for={`help-${key}`}>
                                                            <MyRadio
                                                                color="primary"
                                                                name={"otro"}
                                                                onChange={this.handleChangeRadio.bind(this)}
                                                                checked={this.state.otroValorChecked}
                                                                value={this.state.otroValor}
                                                            />
                                                            <b>{"Otro valor"}</b>
                                                        </small>
                                                        <div
                                                            style={{
                                                                maxWidth: "100px"
                                                            }}
                                                        >
                                                            <MyCampo
                                                                type="mount"
                                                                placeholder={"Otro valor"}
                                                                value={this.state.otroValor}
                                                                name={"otroValor"}
                                                                onChangeValor={this.changeOtroValor.bind(this)}
                                                                obligatory={false}
                                                                disabled={!this.state.otroValorChecked}
                                                            />
                                                        </div>
                                                    </Flex>
                                                )
                                            }
                                        </div>
                                    ) : (
                                        <div>
                                            <Flex
                                                jc={"space-between"}
                                                className={"py-1 px-3"}
                                                key={`inf-${key}`}
                                            >
                                                {inf.ayuda !== "" && (
                                                    <ReactTooltip
                                                        id={`help-${key}`}
                                                        place="right"
                                                        type="info"
                                                        effect="solid"
                                                    >
                                                        {inf.ayuda}
                                                    </ReactTooltip>
                                                )}

                                                <small data-tip data-for={`help-${key}`}>
                                                    <b>{inf.titulo}</b>
                                                </small>
                                                <small className={"mb-0 cg"}>{inf.valor}</small>
                                                <Line dotted className={"wc"}/>
                                            </Flex>
                                            {
                                                key === this.state.infoFactura.length - 1 &&
                                                opcionesRecaudo &&
                                                opcionesRecaudo.modificarValorPagar.activo && (
                                                    <Flex
                                                        jc={"space-between"}
                                                        className={"py-1 px-3"}
                                                        key={`inf-${key}`}
                                                    >
                                                        {opcionesRecaudo &&
                                                        opcionesRecaudo.modificarValorPagar.activo && (
                                                            <ReactTooltip
                                                                id={`help-${key}`}
                                                                place="right"
                                                                type="info"
                                                                effect="solid"
                                                            >
                                                                {opcionesRecaudo.modificarValorPagar.opcion === "<"
                                                                    ? "Editar el valor de la factura por un valor igual o inferior"
                                                                    : opcionesRecaudo.modificarValorPagar.opcion ===
                                                                    ">"
                                                                        ? "Editar el valor de la factura por un valor igual o superior"
                                                                        : "Editar el valor a pagar de la factura"}
                                                            </ReactTooltip>
                                                        )}
                                                        <small data-tip data-for={`help-${key}`}>
                                                            <MyRadio
                                                                color="primary"
                                                                name={"otro"}
                                                                onChange={this.handleChangeRadio.bind(this)}
                                                                checked={this.state.otroValorChecked}
                                                                value={this.state.otroValor}
                                                            />
                                                            <b>{"Otro valor"}</b>
                                                        </small>
                                                        <div
                                                            style={{
                                                                maxWidth: "100px"
                                                            }}
                                                        >
                                                            <MyCampo
                                                                type="mount"
                                                                placeholder={"Otro valor"}
                                                                value={this.state.otroValor}
                                                                name={"otroValor"}
                                                                onChangeValor={this.changeOtroValor.bind(this)}
                                                                obligatory={false}
                                                                disabled={!this.state.otroValorChecked}
                                                            />
                                                        </div>
                                                    </Flex>
                                                )
                                            }
                                        </div>
                                    );
                                })}
                                <div
                                    className="col-12 col-md-4 col-lg-4"
                                    onClick={() => this.downloadPdf()}
                                    style={{lineHeight: "0"}}
                                >
                                    <Btn
                                        bg
                                        hg={"35"}
                                        loading  = { this.state.loadingDownload}
                                        disabled = { this.state.loading}
                                    >
                                        {!this.state.loadingDownload &&
                                        <Fragment>
                                            <img
                                                src="https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/download.png"
                                                alt=""
                                                className={"mr-2"}
                                            />
                                            DESCARGAR
                                        </Fragment>}
                                    </Btn>
                                </div>
                                <a hidden id="pdf"></a>
                            </div>
                            <Line />
                            <Flex className="col-12 px-lg-4 fixed-to-bottom">
                                {/*<div className="col-12 col-md-6 pl-md-0">*/}
                                {/*    <MyCampo*/}
                                {/*        label={"Correo electrónico"}*/}
                                {/*        placeholder={"ej: sucrreo@ejemplo.com"}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                {/*<div className="col-12 col-md-6 pr-md-0">*/}
                                {/*    <MyCampo*/}
                                {/*        label={"Número celular"}*/}
                                {/*        placeholder={"1234566210"}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                <div className="col-12 pt-3 px-md-0">
                                    <Btn
                                        loading={this.state.loading}
                                        disabled={this.state.loading}
                                        onClick={() => this.openCheckout()}
                                    >
                                     Pagar
                                    </Btn>
                                </div>
                            </Flex>
                        </div>
                    </Mycard>
                </Elastic>
            );
        }else if (
            opcionesRecaudo !== "" &&
            opcionesRecaudo &&
            opcionesRecaudo.modificarValorPagar.activo &&
            facturas.length === 1
        ){
            return (
                <Elastic
                    felx={"1 0 auto"}
                    className={"wc cambio "}
                    css={css`animation: ${Transition} 1s cubic-bezier(0.075, 0.82, 0.165, 1) 1;`}
                >
                    <Mycard
                        title={`${this.state.infoCabecera.titulo} ${this.state.infoCabecera.valor}`}
                        back={
                            facturas && facturas.length > 1
                                ? sessionStorage.getItem("facturaPagar")
                                ? ruta.facturas
                                : ruta.home
                                : ruta.home
                        }
                        className={" col-12 col-lg-10 col-xl-7 mx-auto px-0"}
                        footer={this.state.infoEmpresa.mostrarDatos == 1 && <FooterFactura info={this.state.infoEmpresa}/>}
                        history={this.props.history}
                        visible
                    >
                        <div className="wc">
                                <CustomizedSnackbars
                                    message={this.state.showMessage.message}
                                    type={'info'}
                                    visible={this.state.showMessage.open}
                                    isClosed={true}
                                    onClose={this.closedAlert}
                                />
                            <div className="col-12 pb-3">
                                <Flex jc={"space-between"} className={"py-1 px-3"}>
                                    <b className={"cg"}>Descripción</b>
                                    <Line dotted className={"wc"}/>
                                </Flex>

                                {this.state.infoFactura.map((inf, key) => {
                                    return (
                                        this.state.infoFactura.length-1===key
                                            ?<div><Flex
                                                jc={"space-between"}
                                                className={"py-1 px-3"}
                                                key={`inf-${key}`}
                                            >
                                                {inf.ayuda !== "" && (
                                                    <ReactTooltip
                                                        id={`help-${key}`}
                                                        place="right"
                                                        type="info"
                                                        effect="solid"
                                                    >
                                                        {inf.ayuda}
                                                    </ReactTooltip>
                                                )}

                                                <small data-tip data-for={`help-${key}`}>
                                                    <b>{inf.titulo}</b>
                                                </small>
                                                <small className={"mb-0 cg"}>{inf.valor}</small>
                                                <Line dotted className={"wc"}/>

                                            </Flex>
                                                <Flex
                                                    jc={"space-between"}
                                                    className={"py-1 px-3"}
                                                    key={`inf-${key}`}
                                                >
                                                    {opcionesRecaudo &&
                                                    opcionesRecaudo.modificarValorPagar.activo && (
                                                        <ReactTooltip
                                                            id={`help-${key}`}
                                                            place="right"
                                                            type="info"
                                                            effect="solid"
                                                        >
                                                            {opcionesRecaudo.modificarValorPagar.opcion === "<"
                                                                ? "Editar el valor de la factura por un valor igual o inferior"
                                                                : opcionesRecaudo.modificarValorPagar.opcion ===
                                                                ">"
                                                                    ? "Editar el valor de la factura por un valor igual o superior"
                                                                    : "Editar el valor a pagar de la factura"}
                                                        </ReactTooltip>
                                                    )}
                                                    <small data-tip data-for={`help-${key}`}>
                                                        <MyRadio
                                                            color="primary"
                                                            name={"otro"}
                                                            onChange={this.handleChangeRadio.bind(this)}
                                                            checked={this.state.otroValorChecked}
                                                            value={this.state.otroValor}
                                                        />
                                                        <b>{"Otro valor"}</b>
                                                    </small>
                                                    <div
                                                        style={{
                                                            maxWidth: "100px"
                                                        }}
                                                    >
                                                        <MyCampo
                                                            type="mount"
                                                            placeholder={"Otro valor"}
                                                            value={this.state.otroValor}
                                                            name={"otroValor"}
                                                            onChangeValor={this.changeOtroValor.bind(this)}
                                                            obligatory={false}
                                                            disabled={!this.state.otroValorChecked}
                                                        />
                                                    </div>
                                                </Flex>
                                            </div>
                                            :<Flex
                                                jc={"space-between"}
                                                className={"py-1 px-3"}
                                                key={`inf-${key}`}
                                            >
                                                {inf.ayuda !== "" && (
                                                    <ReactTooltip
                                                        id={`help-${key}`}
                                                        place="right"
                                                        type="info"
                                                        effect="solid"
                                                    >
                                                        {inf.ayuda}
                                                    </ReactTooltip>
                                                )}

                                                <small data-tip data-for={`help-${key}`}>
                                                    <b>{inf.titulo}</b>
                                                </small>
                                                <small className={"mb-0 cg"}>{inf.valor}</small>
                                                <Line dotted className={"wc"}/>
                                            </Flex>
                                    );
                                })}
                                <div
                                    className="col-12 col-md-4 col-lg-4 mt-3"
                                    onClick={() => this.downloadPdf()}
                                    style={{lineHeight: "0"}}
                                >
                                    <Btn
                                        bg
                                        hg={"35"}
                                        disabled={this.state.loading}
                                        loading={this.state.loadingDownload}
                                    >
                                        <img
                                            src="https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/download.png"
                                            alt=""
                                            className={"mr-2"}
                                        />
                                        DESCARGAR
                                    </Btn>
                                </div>
                                <a hidden id="pdf"> </a>
                            </div>
                            <Line/>
                            <Flex alg={"flex-start"} className="col-12 px-lg-4 pt-3">
                                <div
                                    className={
                                        this.state.infoEmpresa.suscripcionProyecto
                                            ? "col-6 pt-3"
                                            : "col-12 pt-3  px-md-0"
                                    }
                                >
                                    <Btn
                                        loading={this.state.loading}
                                        disabled={this.state.loading}
                                        onClick={() => this.openCheckout()}
                                    >
                                        {this.state.loading ? "" : "Pagar"}
                                    </Btn>
                                </div>
                                {this.state.infoEmpresa.suscripcionProyecto &&
                                !this.state.isSuscrito ? (
                                    <div className="col-6 pt-3">
                                        <Btn
                                            id="open-checkout"
                                            loading={this.state.loadingSuscripciones}
                                            disabled={this.state.loadingSuscripciones}
                                            onClick={() => {
                                                this.handleScriptLoad();
                                                this.setState({ loadingSuscripciones: true });
                                            }}
                                        >
                                            {!this.state.loadingSuscripciones && "Suscribir factura"}
                                        </Btn>
                                    </div>
                                ) : this.state.isSuscrito ? (
                                    <div className="col-6 pt-3">
                                        <Btn
                                            id="open-checkout"
                                            loading={this.state.loadingSuscripcione}
                                            disabled={this.state.loadingSuscripciones}
                                            onClick={() => {
                                                this.handleScriptLoad();
                                                this.setState({ loadingSuscripciones: true });
                                            }}
                                        >
                                            {!this.state.loadingSuscripciones && "Administrar suscripción"}
                                        </Btn>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </Flex>
                        </div>
                    </Mycard>
                </Elastic>
            )
        }else if(
            opcionesRecaudo !== "" &&
            opcionesRecaudo &&
            opcionesRecaudo.agruparFacturas.activo &&
            this.state.facturas.length > 1
        ){

            return (
                <Elastic
                    felx={"1 0 auto"}
                    className={"wc cambio "}
                    css={css`animation: ${Transition} 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 1;`}
                >
                    <Mycard
                        title={`Pagos Online`}
                        back={
                            facturas && facturas.length > 1
                                ? sessionStorage.getItem("facturaPagar")
                                ? ruta.facturas
                                : ruta.home
                                : ruta.home
                        }
                        className={" col-12 col-lg-10 col-xl-7 mx-auto px-0"}
                        footer={this.state.infoEmpresa.mostrarDatos == 1 && <FooterFactura info={this.state.infoEmpresa}/>}
                        history={this.props.history}
                        visible
                    >
                        <div className="wc">
                                <CustomizedSnackbars
                                    message={this.state.showMessage.message}
                                    type={'info'}
                                    visible={this.state.showMessage.open}
                                    isClosed={true}
                                    onClose={this.closedAlert}
                                />
                            <div className="col-12 pb-3">
                                <Flex jc={"space-between"} className={"py-1 px-3"}>
                                    <b className={"cg"}>Descripción</b>
                                    <Line dotted className={"wc"}/>
                                </Flex>
                                {this.state.facturas.map((fac, key) => {
                                    return(
                                        <div style={{padding:"0.7vw"}}>
                                            <Flex
                                                jc={"space-between"}
                                                className={"py-1 px-3"}
                                                key={`inf-${key}`}
                                            >
                                                <small data-tip data-for={`help-${key}`}>
                                                    <b>Factura #{key+1}</b>
                                                </small>
                                                <button
                                                style={{background:"#F4F5F7",width:"30px", outline:"none"}}
                                                onClick={() => {
                                                    this.setState(state => ({
                                                        ...state,
                                                        facturas: state.facturas.map((item,index) =>
                                                          index == key ? { ...item, expanded: !item.expanded } : item
                                                        )
                                                      }));
                                                }}>
                                                    {
                                                        fac["expanded"] ?
                                                            <i class="fas fa-angle-up"></i>
                                                        : <i class="fas fa-angle-down"></i>
                                                    }
                                                </button>
                                            </Flex>
                                            <Line dotted className={"wc"}/>
                                            <Collapse in={fac["expanded"]} timeout="auto" unmountOnExit>
                                                {
                                                        Object.keys(fac).map((inf, key2) => {
                                                            let data = this.state.infoFactura.find(val => val.entidad == inf);
                                                            let configCampo = this.state.configuracionCampos.find(value => value.tipoCampo == inf);
                                                            configCampo = configCampo ? configCampo.configCampo : null;
                                                            if (data) {
                                                                return (
                                                                    <Flex
                                                                        jc={"space-between"}
                                                                        className={"py-1 px-3"}
                                                                        key={`inf-${inf}`}
                                                                    >
                                                                        <small data-tip data-for={`help-${inf}`}>
                                                                            <b>{data.titulo}</b>
                                                                        </small>
                                                                        {
                                                                            inf == "total" || inf == "iva" ?
                                                                                <small className={"mb-0 cg"}>{`$ ${fac[inf].toLocaleString("en-US", {
                                                                                    minimumFractionDigits: 0
                                                                                })} ${opcionesRecaudo.moneda.value}`}</small>
                                                                                : <small className={"mb-0 cg"}>{configCampo == "password" ? "********" : fac[inf]}</small>

                                                                        }
                                                                        <Line dotted className={"wc"} />
                                                                    </Flex>
                                                                )
                                                            }
                                                        })
                                                    }
                                                <Flex
                                                    jc={"space-between"}
                                                    className={"py-1 px-3"}
                                                >
                                                    <small data-tip >
                                                        <b>Monto a Pagar</b>
                                                    </small>
                                                    {
                                                        <small className={"mb-0 cg"}>{`$ ${this.state.objectValor[key].toLocaleString("en-US", {
                                                            minimumFractionDigits: 0
                                                        })} ${opcionesRecaudo.moneda.value}`}</small>

                                                    }
                                                    <Line dotted className={"wc"}/>
                                                </Flex>
                                            </Collapse>
                                        </div>
                                    )
                                })}
                                <div
                                    className="col-12 col-md-4 col-lg-4 mt-3"
                                    onClick={() => this.downloadPdf()}
                                    style={{lineHeight: "0"}}
                                >
                                    <Btn
                                        bg
                                        hg={"35"}
                                        loading={this.state.loadingDownload}
                                        disabled={this.state.loadingSuscripciones || this.state.loading}
                                    >
                                        {this.state.loadingDownload ? (
                                            ""
                                        ) : (
                                            <Fragment>
                                                <img
                                                    src="https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/download.png"
                                                    alt=""
                                                    className={"mr-2"}
                                                />
                                                DESCARGAR
                                            </Fragment>
                                        )}
                                    </Btn>
                                </div>
                                <a hidden id="pdf"></a>
                            </div>
                            <Line></Line>
                            <Flex alg={"flex-start"} className="col-12 px-lg-4 pt-3 fixed-to-bottom">
                                {/*<div className="col-12 col-md-6 pl-md-0">*/}
                                {/*    <MyCampo*/}
                                {/*        label={"Correo electrónico"}*/}
                                {/*        placeholder={"ej: sucrreo@ejemplo.com"}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                {/*<div className="col-12 col-md-6 pr-md-0">*/}
                                {/*    <MyCampo*/}
                                {/*        label={"Número celular"}*/}
                                {/*        placeholder={"1234566210"}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                <div
                                    className={
                                        this.state.infoEmpresa.suscripcionProyecto
                                            ? "col-6 pt-3"
                                            : "col-12 pt-3  px-md-0 "
                                    }
                                >
                                    <Btn
                                        loading  = { this.state.loading }
                                        disabled = { this.state.loadingSuscripciones || this.state.loadingDownload }
                                        onClick  = { () => this.openCheckout() }
                                    >
                                        Pagar
                                    </Btn>
                                </div>
                                {this.state.infoEmpresa.suscripcionProyecto &&
                                !this.state.isSuscrito ? (
                                    <div className="col-6 pt-3">
                                        <Script
                                            url={process.env.REACT_APP_SCRIPT_CHECKOUT}
                                            onLoad={this.handleScriptLoad.bind(this)}
                                        />
                                        <Btn
                                            id="open-checkout"
                                            loading={this.state.loadingSuscripciones}
                                            disabled={this.state.loadingSuscripciones}
                                            onClick={() =>
                                                this.setState({loadingSuscripciones: true})
                                            }
                                        >
                                            {this.state.loadingSuscripciones
                                                ? ""
                                                : "Suscribir factura"}
                                        </Btn>
                                    </div>
                                ) : this.state.isSuscrito ? (
                                    <div className="col-6 pt-3">
                                        <Script
                                            url={process.env.REACT_APP_SCRIPT_CHECKOUT}
                                            onLoad={this.handleScriptLoad.bind(this)}
                                        />
                                        <Btn
                                            id="open-checkout"
                                            loading={this.state.loadingSuscripciones }
                                            disabled={this.state.loadingSuscripciones}
                                            onClick={() =>
                                                this.setState({loadingSuscripciones: true})
                                            }
                                        >
                                          Administrar suscripción
                                        </Btn>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </Flex>
                        </div>
                    </Mycard>
                </Elastic>
            );
        }else {
            return (
                <Elastic
                    felx={"1 0 auto"}
                    className={"wc cambio "}
                    css={css`animation: ${Transition} 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 1;`}
                >
                    <Mycard
                        title={`Pagos Online`}
                        back={
                            facturas && facturas.length > 1
                                ? sessionStorage.getItem("facturaPagar")
                                ? ruta.facturas
                                : ruta.home
                                : ruta.home
                        }
                        className={" col-12 col-lg-10 col-xl-7 mx-auto px-0"}
                        footer={this.state.infoEmpresa.mostrarDatos == 1 && <FooterFactura info={this.state.infoEmpresa}/>}
                        history={this.props.history}
                        visible
                    >
                        <div className="wc">
                                <CustomizedSnackbars
                                    message={this.state.showMessage.message}
                                    type={'info'}
                                    visible={this.state.showMessage.open}
                                    isClosed={true}
                                    onClose={this.closedAlert}
                                />
                            <div className="col-12 pb-3">
                                <Flex jc={"space-between"} className={"py-1 px-3"}>
                                    <b className={"cg"}>Descripción</b>
                                    <Line dotted className={"wc"}/>
                                </Flex>
                                {this.state.infoFactura.map((inf, key) => {

                                    return (
                                        <Flex
                                            jc={"space-between"}
                                            className={"py-1 px-3"}
                                            key={`inf-${key}`}
                                        >
                                            {inf.ayuda !== "" && (
                                                <ReactTooltip
                                                    id={`help-${key}`}
                                                    place="right"
                                                    type="info"
                                                    effect="solid"
                                                >
                                                    {inf.ayuda}
                                                </ReactTooltip>
                                            )}

                                            <small data-tip data-for={`help-${key}`}>
                                                <b>{inf.titulo}</b>
                                            </small>
                                            <small className={"mb-0 cg"}>{this.FormatoCampo(inf)}</small>
                                            <Line dotted className={"wc"}/>
                                        </Flex>
                                    );
                                })}
                                <div
                                    className="col-12 col-md-4 col-lg-4 mt-3"
                                    onClick={() => this.downloadPdf()}
                                    style={{lineHeight: "0"}}
                                >
                                    <Btn
                                        bg
                                        hg={"35"}
                                        loading={this.state.loadingDownload}
                                        disabled={this.state.loadingSuscripciones || this.state.loading}
                                    >
                                        {this.state.loadingDownload ? (
                                            ""
                                        ) : (
                                            <Fragment>
                                                <img
                                                    src="https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/download.png"
                                                    alt=""
                                                    className={"mr-2"}
                                                />
                                                DESCARGAR
                                            </Fragment>
                                        )}
                                    </Btn>
                                </div>
                                <a hidden id="pdf"></a>
                            </div>
                            <Line></Line>
                            <Flex alg={"flex-start"} className="col-12 px-lg-4 pt-3 fixed-to-bottom">
                                {/*<div className="col-12 col-md-6 pl-md-0">*/}
                                {/*    <MyCampo*/}
                                {/*        label={"Correo electrónico"}*/}
                                {/*        placeholder={"ej: sucrreo@ejemplo.com"}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                {/*<div className="col-12 col-md-6 pr-md-0">*/}
                                {/*    <MyCampo*/}
                                {/*        label={"Número celular"}*/}
                                {/*        placeholder={"1234566210"}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                <div
                                    className={
                                        this.state.infoEmpresa.suscripcionProyecto
                                            ? "col-6 pt-3"
                                            : "col-12 pt-3  px-md-0 "
                                    }
                                >
                                    <Btn
                                        loading  = { this.state.loading }
                                        disabled = { this.state.loadingSuscripciones || this.state.loadingDownload }
                                        onClick  = { () => this.openCheckout() }
                                    >
                                        Pagar
                                    </Btn>
                                </div>
                                {this.state.infoEmpresa.suscripcionProyecto &&
                                !this.state.isSuscrito ? (
                                    <div className="col-6 pt-3">
                                        <Script
                                            url={process.env.REACT_APP_SCRIPT_CHECKOUT}
                                            onLoad={this.handleScriptLoad.bind(this)}
                                        />
                                        <Btn
                                            id="open-checkout"
                                            loading={this.state.loadingSuscripciones}
                                            disabled={this.state.loadingSuscripciones}
                                            onClick={() =>
                                                this.setState({loadingSuscripciones: true})
                                            }
                                        >
                                            {this.state.loadingSuscripciones
                                                ? ""
                                                : "Suscribir factura"}
                                        </Btn>
                                    </div>
                                ) : this.state.isSuscrito ? (
                                    <div className="col-6 pt-3">
                                        <Script
                                            url={process.env.REACT_APP_SCRIPT_CHECKOUT}
                                            onLoad={this.handleScriptLoad.bind(this)}
                                        />
                                        <Btn
                                            id="open-checkout"
                                            loading={this.state.loadingSuscripciones }
                                            disabled={this.state.loadingSuscripciones}
                                            onClick={() =>
                                                this.setState({loadingSuscripciones: true})
                                            }
                                        >
                                          Administrar suscripción
                                        </Btn>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </Flex>
                        </div>
                    </Mycard>
                </Elastic>
            );
        }
    }
}

export default withRouter(FacturaPagarOnline);
